$(document).ready(function () {
  $(".Special_Faqs .faq-answer").each(function() {
    $("<div class='faq-spacer'></div>").insertAfter($(this));
  });

  $('.slider .header-img').each(function() {
    if ($(this).children('.caption-wrapper').length) {
      $(this).closest(".header-img").addClass('active-overlay');
    }
  });
});

const mediaQuery = window.matchMedia('(min-width: 1px)')

function handleTabletChange(e) {
  if (e.matches) {
    $(window).on('load resize scroll', function () {
      var teaserHight = $(".contact-information-inner").height();
      $(".slider_contact-wrapper").css("margin-top", "-" + (teaserHight / 2) + "px");
     //  $(".slider_contact-wrapper").css("margin-bottom", + (teaserHight / 2) + "px");
    });
  }
}

mediaQuery.addListener(handleTabletChange)

handleTabletChange(mediaQuery)